import React, {Component} from 'react'
import PropTypes from 'prop-types'
// import {useDropzone} from 'react-dropzone'

// function UploadDropZone() {
//   const onDrop = useCallback(acceptedFiles => {
//     const reader = new FileReader()

//     reader.onabort = () => console.log('file reading was aborted')
//     reader.onerror = () => console.log('file reading has failed')
//     reader.onload = () => {
//       // Do whatever you want with the file contents
//       const binaryStr = reader.result
//       console.log(binaryStr)
//     }

//     acceptedFiles.forEach(file => reader.readAsBinaryString(file))
//   }, [])
//   const {getRootProps, getInputProps, isDragActive} = useDropzone({onDrop})

//   return (
//     <div {...getRootProps()}>
//       <input {...getInputProps()} />
//       <p>Drag 'n' drop some files here, or click to select files</p>
//     </div>
//   )
// }





class UploadDropZone extends Component {
    constructor(props) {
        super(props);
        this.state = {editable: false};
        this.handleDragOver = this.handleDragOver.bind(this);
        this.handleFileSelect = this.handleFileSelect.bind(this);
    }


    handleDragOver(evt) {
        evt.stopPropagation();
        evt.preventDefault();
        evt.dataTransfer.dropEffect = 'copy'; // Explicitly show this is a copy.
    }

    handleFileSelect(evt) {
        evt.stopPropagation();
        evt.preventDefault();

        var files = evt.target.files? evt.target.files: evt.dataTransfer.files; // FileList object
         // Loop through the FileList and load them all
        for (var i = 0; i < files.length; i++) {
            var f = files[i]
            var reader = new FileReader();
            reader.onload = this.props.onFileLoad;
            // Read in the image file as a data URL.
            // reader.readAsDataURL(f);
            reader.readAsText(f, "UTF-8");
        }
        
    }

    render() {
        return (
            <div onDragOver={this.handleDragOver} >
                <span>Add transaction records</span>
                <input type="file" id="files" name="files[]" multiple={true} onChange={this.handleFileSelect} />
            </div>
        );
    }
}


export default UploadDropZone;

UploadDropZone.propTypes = {
  onFileLoad: PropTypes.func.isRequired
}

UploadDropZone.defaultProps = {
};